import { Export } from '@adgate/common/interfaces/export.interface';
import { Filter } from '@adgate/common/interfaces/filter.interface';
import { QuickSearch } from '@adgate/common/interfaces/quick-search.interface';
import { Tab, TabAccessorInterface } from '@adgate/common/interfaces/tab-accessor.interface';
import { AuthenticationService } from '@adgate/common/services/authentication-service';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { StreamingCreativityGridComponent } from '@adgate/modules/streaming/components/streaming-creativity-grid-component/streaming-creativity-grid-component';
import { StreamingCampaignGridComponent } from '@adgate/modules/streaming/components/streaming-campaign-grid-component/streaming-campaign-grid-component';
import { CreativityFilter } from '@adgate/modules/streaming/types/creativity-filter.type';
import { Status } from '@adgate/common/types/status.type';
import { User } from '@adgate/modules/admin/types/user.type';

@Component({
  selector: 'streaming-main-component',
  imports: [StreamingCampaignGridComponent, StreamingCreativityGridComponent],
  templateUrl: './streaming-main-component.html',
  styleUrl: './streaming-main-component.scss',
})
export class StreamingMainComponent extends TabAccessorInterface implements OnInit, QuickSearch, Export, Filter
{
  @ViewChild('tabCampaign') tabCampaignComponent?: StreamingCampaignGridComponent;
  @ViewChild('tabPending') tabPendingComponent?: StreamingCreativityGridComponent;
  @ViewChild('tabHistory') tabHistoryComponent?: StreamingCampaignGridComponent;

  public TAB_PENDINGREJECTED: number    = 0;
  public TAB_CAMPAIGN: number           = 1;
  public TAB_HISTORY: number            = 2;

  private authService:AuthenticationService = inject(AuthenticationService);

  pendingRejectedFilter!: CreativityFilter;
  latestFilter!: CreativityFilter;

  constructor()
  {
    super();

    let userAttributes = this.authService.getUserAttributes();

    this.pendingRejectedFilter = new CreativityFilter();
    this.pendingRejectedFilter.status = [{id: Status.STREAMING_CREATIVITY_CREATED, description:''}, {id: Status.STREAMING_CREATIVITY_REJECTED, description: ''}, {id: Status.STREAMING_CREATIVITY_RELOAD, description: ''}, {id: Status.STREAMING_CREATIVITY_SPECERROR, description:''}];

    this.latestFilter = new CreativityFilter();
    this.latestFilter.createdFrom = Date.now() - (7 * 24 * 60 * 60 * 1000);
    this.latestFilter.createdTo = Date.now() + (1 * 24 * 60 * 60 * 1000);

    if (userAttributes.type == User.TYPE_OFFICE) {
      this.pendingRejectedFilter.commercialOffice = [userAttributes.office];
      this.latestFilter.commercialOffice = [userAttributes.office];
    } 
    
    if (userAttributes.type == User.TYPE_AGENCY) {
      this.pendingRejectedFilter.agency = [userAttributes.agency];
      this.latestFilter.agency = [userAttributes.agency];
    }

    this.setActiveTab(this.TAB_PENDINGREJECTED);
  }

  ngOnInit(): void
  {
    this.setActiveTab(this.TAB_PENDINGREJECTED);
  }

  override getTabs(): Tab[] 
  {
    return [
      {tabNum: 0, tabDescription: 'Pending/Rejected', show: true},
      {tabNum: 1, tabDescription: 'Campaigns', show: true},
      {tabNum: 2, tabDescription: 'History', show: true}
    ];
  }

  onRefresh()
  {
    const activeTabComponent = this.getActiveTabComponent();
    activeTabComponent.onRefresh();
  }

  showFilters(): boolean 
  {
    try {
      const activeTabComponent = this.getActiveTabComponent();
      return activeTabComponent?.showFilters() || false;
    } catch {
      return false;
    }        
  }

  onFilter()
  {
    const activeTabComponent = this.getActiveTabComponent();
    activeTabComponent.onFilter();
  }

  onExport()
  {
    const activeTabComponent = this.getActiveTabComponent();
    activeTabComponent.onExport();
  }

  getQuickSearchPlaceholder(): string 
  {
    try {
      const activeTabComponent = this.getActiveTabComponent();
      return activeTabComponent?.getQuickSearchPlaceholder() || '';
    } catch {
      return '';
    }    
  }

  onQuickSearch(filter: string | null): void 
  {
    const activeTabComponent = this.getActiveTabComponent();
    activeTabComponent.onQuickSearch(filter);
  }

  getActiveTabComponent(): any 
  {
    switch (this.getActiveTab()) {
      case this.TAB_CAMPAIGN:
        return this.tabCampaignComponent!;
      case this.TAB_PENDINGREJECTED:
        return this.tabPendingComponent!;
      case this.TAB_HISTORY:
        return this.tabHistoryComponent!;
      default:
        throw new Error('Unknown active tab');
    }
  }

  onNewCampaign()
  {
    switch (this.getActiveTab()) {
      case this.TAB_CAMPAIGN:
        return this.tabCampaignComponent!.onNewCampaign();
      case this.TAB_PENDINGREJECTED:
        return this.tabPendingComponent!.onNewCampaign();
      case this.TAB_HISTORY:
        return this.tabHistoryComponent!.onNewCampaign();
      default:
        throw new Error('Unknown active tab');
    }
  }
}
